export default __webpack_public_path__ + "static/media/bannerCar.776986cb.png";